<!-- <div class="bg-yellow-600 text-xl flex align-items-center justify-content-center gap-4 p-4">
  <img class="cursor-pointer transition-all transition-duration-300 max-w-full" id="logo" src="assets/logo-{{api.pro ? 'blanc' : 'slim-notext'}}.png"/>
  <div>  Le site est en maintenance pour quelques heures ! 
    <br/>À tout de suite !
  </div>
</div> -->
<div *ngIf="api.loading" style="position: fixed; top:0px; left:-3px; right: -3px;">  
  <p-progressBar mode="indeterminate" ></p-progressBar>
</div>
<router-outlet></router-outlet>
<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-text p-button-plain" acceptButtonStyleClass="p-button-outlined p-button-success" header="Confirmation"  icon="pi pi-exclamation-triangle" acceptLabel="Oui" rejectLabel="Non" [position]="api.adminOrder ? 'top' : 'center'">
</p-confirmDialog>
